webpackJsonp([0],[
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_header__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_footer__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_footer__);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{
        path: '/',
        components: {
            header: __WEBPACK_IMPORTED_MODULE_2__components_header___default.a,
            home: __WEBPACK_IMPORTED_MODULE_3__components_home___default.a,
            footer: __WEBPACK_IMPORTED_MODULE_4__components_footer___default.a
        },
        beforeEnter: function beforeEnter(to, from, next) {
            [].forEach.call(document.getElementsByTagName('li'), function (item) {
                item.className = '';
            });
            next();
        }
    }],
    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
        console.log(to, from, savedPosition);
        return { x: 0, y: 0 };
    },

    mode: 'hash'
}));

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(10)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(5),
  /* template */
  __webpack_require__(20),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app"
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(0);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "footer",
  data: function data() {
    return {
      navItems: navItems,
      src: "/static/img/dy_foot_bg.png"
    };
  },

  methods: {}
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(0);


var navItems = [{
  text: "首页",
  fit_text: "Home",
  link: "/"
}, {
  text: "产品中心",
  fit_text: "About us",
  link: "/about"
}, {
  text: "技术支持",
  fit_text: "product",
  link: "/product"
}, {
  text: "成功案例",
  fit_text: "project",
  link: "/partnersList"
}, {
  text: "关于我们",
  fit_text: "news",
  link: "/newsList"
}];

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "header",
  data: function data() {
    return {
      navItems: navItems,
      navIn: "nav-out",
      navActionView: "none"
    };
  },

  methods: {
    toLink: function toLink(link, $event) {
      [].forEach.call(document.getElementsByTagName("li"), function (item) {
        item.className = "";
      });
      $event.target.className = "selected";
      if (link == "/product") {
        this.navActionView = "";
      } else {
        this.navActionView = "none";
      }
      __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push(link || "/");
    },
    toLinkAction: function toLinkAction(link) {
      this.navActionView = "none";
      __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push(link || "/");
    },
    addClass: function addClass(link, $event) {
      if (!$event.target.className.match(new RegExp("(\\s|^)" + "selected" + "(\\s|$)"))) {
        $event.target.className = " ";
      }
      if (!$event.target.className.match(new RegExp("(\\s|^)" + "nav-in" + "(\\s|$)"))) {
        $event.target.className += " " + "nav-in";
      }
      if (link == "/product") {
        this.navActionView = "";
      } else {
        this.navActionView = "none";
      }
    },
    rmClass: function rmClass(link, $event) {
      if (!$event.target.className.match(new RegExp("(\\s|^)" + "selected" + "(\\s|$)"))) {
        $event.target.className = " ";
      }
      if (!$event.target.className.match(new RegExp("(\\s|^)" + "nav-out" + "(\\s|$)"))) {
        $event.target.className += " " + "nav-out";
      }
      if (link == "/product") {
        this.navActionView = "";
      } else {
        this.navActionView = "none";
      }
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "home",
  data: function data() {
    return {
      planList: this.newsData.planList,
      classicProjectList: this.newsData.classicProjectList,
      homeNewsData: this.newsData.homeNewsData
    };
  },


  methods: {
    toLink: function toLink(link) {
      __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push(link || "/");
    },
    scrollToTop: function scrollToTop() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    }
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(0);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 10 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(12)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(22),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(13)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(23),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(11)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(21),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    attrs: {
      "name": "header"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "home"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "aboutContent"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "product"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "systemSoft"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "partnersList"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "outlines"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "renovation"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "partnerDetail"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "newsList"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "newsDetail"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "contactUs"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "jobContent"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "footer"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearFloat"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "home_part_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "home_part_2"
  }, [_c('div', {
    staticClass: "home_part_item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("成本控制")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("量身定制，昂科科技为您控制底开发成本")])]), _vm._v(" "), _c('div', {
    staticClass: "home_part_item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("云服务器")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("量身定制，昂科科技为您控制底开发成本")])]), _vm._v(" "), _c('div', {
    staticClass: "home_part_item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("快速开发")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("量身定制，昂科科技为您控制底开发成本")])]), _vm._v(" "), _c('div', {
    staticClass: "home_part_item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("安全稳定")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("量身定制，昂科科技为您控制底开发成本")])]), _vm._v(" "), _c('div', {
    staticClass: "home_part_item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("专业设计")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("量身定制，昂科科技为您控制底开发成本")])])]), _vm._v(" "), _c('div', {
    staticClass: "home_part_3"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("关于我们")]), _vm._v(" "), _c('div', {
    staticClass: "smalltitle"
  }, [_vm._v("全面人性化服务+优秀技术研发团队")]), _vm._v(" "), _c('div', {
    staticClass: "img"
  }), _vm._v(" "), _c('div', {
    staticClass: "content_title"
  }, [_vm._v("江西聚小宝科技有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "content_des"
  }, [_vm._v("江西聚小宝科技有限公司是一家集软件自主研发、运营、维护及服务为一体的技术型公司。形成了内部管理体系、行政审批系统、电子商务管理系统、安全监测管理系统、微信二次开发管理系统等主要产品。并向客户提供专家团队的咨询服务、定制服务、运维服务。我们注重产品质量和优质服务，本着“务实创新，追求卓越”的核心价值观服务客户。")])]), _vm._v(" "), _c('div', {
    staticClass: "home_part_4"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("为什么选择我们")]), _vm._v(" "), _c('div', {
    staticClass: "smalltitle"
  }, [_vm._v("全面人性化服务+优秀技术研发团队")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    staticStyle: {
      "top": "279px",
      "left": "220px"
    }
  }, [_c('div', {
    staticClass: "img",
    staticStyle: {
      "background": "url('/static/img/fz_item_2.png')"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("更短开发周期")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("软件服务是一种把管理软件和实施服务一体化打包的软件服务模式，\n        它包括提供成熟的软件产品、优质的实施培训服务等。软件服务是\n        一种把管理软件和实施服务一体化打包的软件服务模式，它包括提\n        供成熟的软件产品、优质的实施培训服务等。\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "item",
    staticStyle: {
      "top": "279px",
      "left": "980px"
    }
  }, [_c('div', {
    staticClass: "img",
    staticStyle: {
      "background": "url('/static/img/fz_item_1.png')"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("更低产开发成本")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("软件服务是一种把管理软件和实施服务一体化打包的软件服务模式，\n        它包括提供成熟的软件产品、优质的实施培训服务等。软件服务是\n        一种把管理软件和实施服务一体化打包的软件服务模式，它包括提\n        供成熟的软件产品、优质的实施培训服务等。\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "item",
    staticStyle: {
      "top": "539px",
      "left": "220px"
    }
  }, [_c('div', {
    staticClass: "img",
    staticStyle: {
      "background": "url('/static/img/fz_item_3.png')"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("更高产品质量")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("软件服务是一种把管理软件和实施服务一体化打包的软件服务模式，\n        它包括提供成熟的软件产品、优质的实施培训服务等。软件服务是\n        一种把管理软件和实施服务一体化打包的软件服务模式，它包括提\n        供成熟的软件产品、优质的实施培训服务等。\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "item",
    staticStyle: {
      "top": "539px",
      "left": "980px"
    }
  }, [_c('div', {
    staticClass: "img",
    staticStyle: {
      "background": "url('/static/img/fz_item_4.png')"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("更好安全性能")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("软件服务是一种把管理软件和实施服务一体化打包的软件服务模式，\n        它包括提供成熟的软件产品、优质的实施培训服务等。软件服务是\n        一种把管理软件和实施服务一体化打包的软件服务模式，它包括提\n        供成熟的软件产品、优质的实施培训服务等。\n      ")])])])])
}]}

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('img', {
    staticClass: "qrcode"
  }), _vm._v(" "), _c('div', {
    staticClass: "foot_item",
    staticStyle: {
      "margin-left": "180px"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("关于返猪")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("公司介绍")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("加入我们")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("企业历程")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("最新动态")])]), _vm._v(" "), _c('div', {
    staticClass: "foot_item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("用户服务")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("意见反馈")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("返猪协议")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("审查规范")])]), _vm._v(" "), _c('div', {
    staticClass: "foot_item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("产品与服务")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("网站建设")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("微信营销")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("建站快车")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("在线商城")])]), _vm._v(" "), _c('div', {
    staticClass: "foot_item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("商务合作")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("加盟返猪")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("平台合作")])]), _vm._v(" "), _c('div', {
    staticClass: "company",
    attrs: {
      "onclick": "window.open('https://beian.miit.gov.cn')"
    }
  }, [_vm._v("江西聚小宝科技有限公司©2008-2020 赣ICP 备19013683 号")])])
}]}

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "col",
    attrs: {
      "id": "nav"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/img/logo.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header_title"
  }, [_vm._v("江西聚小宝科技有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "nav-item"
  }, [_c('ul', _vm._l((_vm.navItems), function(item) {
    return _c('li', {
      on: {
        "mouseover": function($event) {
          return _vm.addClass(item.link, $event)
        },
        "mouseleave": function($event) {
          return _vm.rmClass(item.link, $event)
        },
        "click": function($event) {
          return _vm.toLink(item.link, $event)
        }
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 0)])])])
},staticRenderFns: []}

/***/ })
],[9]);


// WEBPACK FOOTER //
// static/js/app.d8e65b2a975d4e495d30.js